import { Component, Input, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-header',
  templateUrl: './cap-header.component.html',
  styleUrls: ['./cap-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [RouterLink, TranslatePipe]
})
export class HeaderComponent {

  @Input() appTitleKey: string;
  @Input() appLogo = 'assets/logo.png';
  @Input() welcomePage = '/dashboard';
  toggleKey = 'Close navigation';

  toggleHeader() {
    const e = document.body;
    if (e && e.classList) {
      let closed = e.classList.toggle('close-navigation');
      this.toggleKey = closed ? 'Open navigation' : 'Close navigation';
    }
  }
}
